import React from 'react';
import { Content, Row, Col, Title, Text, Pagination, Image } from 'components';
import { Button, Empty, Flex } from 'antd';
import { encrypt } from 'utils/Crypto';
import Stamp from 'assets/event_stamp.png';

const TAP = [
  {
    label: '전체',
    value: 'ALL',
  },
  {
    label: '진행중',
    value: 'ING',
  },
  {
    label: '진행예정',
    value: 'PREV',
  },
  {
    label: '종료',
    value: 'END',
  },
];

const PAGE_COUNT = 12;
const PAGE_SIZE = 12;

const CouponEventHomePresenter = (props) => {
  /* ===== Props ===== */
  const { navigate, events, screenSize } = props;

  /* ===== State ==== */
  const [eventList, setEventList] = React.useState(events);
  const [activeButton, setActiveButton] = React.useState('ALL');
  const [currentPage, setCurrentPage] = React.useState(1);

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 40 : 28,
      fontFamily: `"Dela Gothic One", sans-serif`,
      fontWeight: 400,
      fontStyle: 'normal',
      textTransform: 'capitalize',
    },
    button: {
      padding: '10px 29px',
      backgroundColor: 'transparent',
      border: '1px solid #ddd',
      color: 'var(--black-color)',
    },
    activeButton: {
      padding: '10px 29px',
      backgroundColor: 'var(--black-color)',
      color: 'white',
    },
    eventContainer: {},
    eventItem: {
      width: '100%', // 기본적으로 3개 열
      boxSizing: 'border-box',
      cursor: 'pointer',
      padding: screenSize >= 768 ? '0 20px' : 0,
    },
    eventImage: {
      width: '100%',
      height: 'auto',
      aspectRatio: '5 / 2.93',
      // maxWidth: screenSize >= 768 ? '443px' : '100%', // 최대 넓이 제한
    },
    eventTitle: {
      fontSize: screenSize >= 768 ? 24 : screenSize >= 500 ? 20 : 16,
      fontWeight: 700,
      margin: '24px 0px 0px',
      cursor: 'pointer',
      webkitLineClamp: 'unset',
    },
    eventDescription: {
      fontSize: screenSize >= 768 ? 18 : 16,
      color: 'var(--dark-gray-color)',
      cursor: 'pointer',
    },
    emptyState: {
      textAlign: 'center',
      padding: 20,
      fontSize: 16,
      color: 'gray',
      width: '100%',
    },
    tapStyle: {
      width: screenSize >= 768 ? 100 : screenSize >= 500 ? 80 : 60,
      height: screenSize >= 768 ? 48 : screenSize >= 500 ? 40 : 35,
      borderRadius: 100,
      fontSize: screenSize >= 768 ? 16 : screenSize >= 500 ? 14 : 13,
    },
  };

  /* ===== Hooks ===== */
  /**
   * 이벤트 목록 정제
   */
  React.useEffect(() => {
    console.log(events, '<< events');
    const filteredEvents = events?.filter((event) =>
      activeButton === 'ALL' ? event : event?.status === activeButton,
    );

    setEventList(filteredEvents);
  }, [activeButton, events]);

  /* ===== Render ====== */
  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '80px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={1} lg={2}></Col>
        <Col x={24} md={22} lg={20}>
          <Content maxWidth={'100%'} padding={0}>
            <Title
              align={'center'}
              style={{
                ...styles.title,
                marginBottom: screenSize >= 768 ? 120 : 60,
              }}
            >
              JM Event
            </Title>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: screenSize >= 768 ? 12 : 7,
                marginBottom: screenSize >= 768 ? 100 : 60,
                //padding: screenSize >= 768 ? 0 : '0 20px',
              }}
            >
              {TAP.map((tab) => (
                <Button
                  key={`tab-${tab.value}`}
                  style={{
                    ...styles.tapStyle,
                    ...(activeButton === tab.value
                      ? styles.activeButton
                      : styles.button),
                  }}
                  onClick={() => setActiveButton(tab.value)}
                >
                  {tab.label}
                </Button>
              ))}
            </div>

            <Row gutter={screenSize >= 500 ? [80, 40] : [40, 20]}>
              {eventList.length ? (
                eventList
                  .sort((a, b) => {
                    if (a.status === 'END' && b.status !== 'END') return 1;
                    if (a.status !== 'END' && b.status === 'END') return -1;
                    return 0;
                  })
                  .slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)
                  .map((event) => (
                    <Col
                      key={`event-${event.event_id}`}
                      x={24}
                      md={12}
                      lg={8}
                      style={styles.eventItem}
                      onClick={() =>
                        navigate(
                          `/events/${encodeURIComponent(
                            encrypt(event?.event_id),
                          )}`,
                        )
                      }
                    >
                      <div
                        style={{
                          position: 'relative',
                          top: 0,
                          left: 0,
                        }}
                      >
                        <Image
                          src={event.src}
                          alt={`${event?.event_title}`}
                          style={{
                            ...styles.eventImage,
                          }}
                        />

                        {event?.status === 'END' ? (
                          <Flex
                            justify="center"
                            align="center"
                            style={{
                              position: 'absolute',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%',
                              background: 'rgba(0, 0, 0, 0.7)',
                            }}
                          >
                            <img src={Stamp} alt="END" width={'40%'} />
                          </Flex>
                        ) : null}
                      </div>
                      <Text style={styles.eventTitle}>
                        {event?.event_title}
                      </Text>
                      <Text style={styles.eventDescription}>
                        {event?.description}
                      </Text>
                    </Col>
                  ))
              ) : (
                <Col x={24} style={styles.emptyState}>
                  <Empty description={'이벤트가 없습니다.'} />
                </Col>
              )}
            </Row>

            {/* 페이지네이션 */}
            <div style={{ marginTop: 100 }}>
              <Pagination
                total={eventList?.length}
                pageSize={PAGE_COUNT}
                current={currentPage} // 상태 동기화
                onChange={(e) => setCurrentPage(e)}
                showSizeChanger
                onShowSizeChange={(current, size) => {
                  setCurrentPage(1); // 페이지 크기 변경 시 페이지 초기화
                }}
                showPage={5}
                buttonStyle={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: '#999999',
                  background: 'none',
                  width: 28,
                  height: 28,
                }}
                isButton={true}
                activeStyle={{
                  color: `var(--black-color) !important`,
                  borderBottom: '2px solid #111111',
                }}
                hoverStyle={{
                  color: `var(--black-color) !important`,
                }}
                navStyle={{
                  border: '1px solid var(--black-color)',
                }}
                isLatestButton={true}
              />
            </div>
          </Content>
        </Col>
        <Col x={0} md={1} lg={2}></Col>
      </Row>
    </Content>
  );
};

export default CouponEventHomePresenter;
